import { styled } from "@mui/material/styles";
import { Container, Typography } from "@mui/material";

export const StyledContainer = styled(Container)(({ theme }) => ({
  padding: "24px 16px 30px",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("mobile")]: {
    padding: "42px 24px 50px",
  },
}));

export const Title = styled(Typography)({
  margin: "0 auto 15px auto",
});

export const ContentReadMore = styled("div")({
  width: 300,
});

export const Description = styled(Typography)({
  margin: "0 auto",
  maxWidth: 710,
});
